import { Outlet, NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

// Minimal nav. commissioning-workflows adds a link here after doctrine approval
// when a workflow route is registered in App.tsx.
const navItems = [
  { to: '/', label: 'Home' },
  { to: '/canon', label: 'canon' },
  // >>> NEW_WORKFLOW_NAV — commissioning-workflows inserts nav links here <<<
]

export function AppShell() {
  return (
    <div className="h-dvh flex flex-col bg-background overflow-hidden">
      {/* Header — centered to align with content */}
      <header className="flex-shrink-0 h-14">
        <div className="max-w-6xl mx-auto px-6 md:px-8 h-full flex items-center justify-between">
          <NavLink to="/" className="group">
            <span className="text-sm font-light tracking-tight text-foreground">
              factory006
            </span>
          </NavLink>

          <nav className="flex items-center gap-6">
            {navItems.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  cn(
                    'text-sm transition-colors',
                    isActive
                      ? 'text-foreground font-medium'
                      : 'text-muted-foreground font-light hover:text-foreground'
                  )
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  )
}
